import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import instance from "@src/api/axiosInstance";
import { message } from 'antd';
import { noop } from 'lodash';

interface ActivatePromptInput {
  id: string;
}

interface ActivatePromptResponse {
  success: boolean;
  prompt: {
    id: string;
    title: string;
    prompt: string;
    active: boolean;
  };
}

const activatePrompt = async (input: ActivatePromptInput): Promise<ActivatePromptResponse> => {
  const url = `/nexa/system-prompt/version/${input.id}/activate`;
  const response = await instance.post(url);
  return response.data;
};

export function useActivatePrompt({ onDone = noop }): UseMutationResult<
  ActivatePromptResponse,
  unknown,
  ActivatePromptInput
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: activatePrompt,
    onSuccess: () => {
      message.info('Prompt activated successfully');
      queryClient.invalidateQueries(['system-prompts']);
      queryClient.invalidateQueries(['system-prompt-versions']);
      onDone();
    },
  });
}
